import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { withRouter } from "react-router-dom";
import uuid from 'uuid/v1';
import moment from 'moment';
import  Page  from '../../components/Page';
import {  SearchBar } from '../../components';
import { NetworkContext } from '../../context/NetworkContext';

import { Header, Results } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    padding: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(3)
  }
}));
export const CommodityList = withRouter(props => {

  const classes = useStyles();
  const [orders, setOrders] = useState([]);
  const { sendNetworkRequest } = React.useContext(NetworkContext);
  async function fetchcommodity(searchtext)
  {
    let commoditylist = await sendNetworkRequest('/admin/getcommoditymaster', {}, {searchtext},true)
    setOrders(commoditylist.module)
    
  }
  useEffect(() => {
    fetchcommodity()
  }, []);
  function applysearch(searchcontent)
  {
    fetchcommodity(searchcontent)
  }
  return (
    <Page
      className={classes.root}
      title="Commodity"
    >
      <Header />
      <SearchBar onSearch={applysearch} placeholder="Search by name"/>

      <Results
        className={classes.results}
        orders={orders} //
      />
     
    </Page>
  );
});

export default CommodityList;
